module.exports = __webpack_public_path__ + "static/sport/out2.4e56ecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/out2.png
// module id = P2cL
// module chunks = 0